/**
 * Apply scaling bias to a normalized value
 * Bias is the amount by which value is modified in terms of 'scaling'
 * 1 Bias will scale value of (1,0) to (1,0) (normalscaling)
 * 0 Bias will scale value of (1,0) to (1,1)(noScaling)
 * @param value 
 * @param bias 
 * @returns 
 */
export function ApplyScalingBias(value: number, bias: number = 1): number
{
    const result: number = bias == 1 ? 
        value : 
        value + (1-value) * (1-bias);
    
    // console.log(result.toFixed(2));
    
    return result;
}